import axios from "axios"
import { data } from "react-router-dom"

export const fetchListApi = () => {
  return axios("api/list").then(res=>{
    return res.data
  }).catch(err=>{
    console.dir(err)
  })
}

export const postListApi = (addList) => {
  return axios({
    url: "api/addlist",
    method:"post",
    data:addList
  }).then(res=>{
    return res.data
  }).catch(err=>{
    console.dir(err);
  })
}
